import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'
import { OrganisationProfileDto } from '../components/Combobox/OrganisationProfileCombobox'

type ReturnProps = {
    loaded: boolean
    organisationProfiles: OrganisationProfileDto[]
    activeOrganisationProfiles: OrganisationProfileDto[]
    getOrganisationProfile: (key: string) => OrganisationProfileDto
}

export default function useOrganisationProfiles(): ReturnProps {
    const { loaded, entities } = useGlobalContext('organisationProfiles')

    const organisationProfiles: OrganisationProfileDto[] = useMemo(
        () => entities?.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) || [],
        [entities],
    )
    const activeOrganisationProfiles = useMemo<OrganisationProfileDto[]>(() => {
        return organisationProfiles.filter(profile => profile.enabled)
    }, [organisationProfiles])

    const getOrganisationProfile = (key: string) => entities.find(value => value.key === key)

    return { loaded, organisationProfiles, activeOrganisationProfiles, getOrganisationProfile }
}
